@if (editableSocialIndex() === null) {
    <web-widget-breadcrumbs [widget]="widget()" [hideBreadcrumbs]="isZero" [isInSpecificSection]="isSpecific()" />
    <div class="panel-options-body overflow-wrapper">
        <div class="form form-horizontal">
            <div class="form-row">
                <div class="form-group mb-20">
                    <div
                        class="col-xs-12"
                        cdkDropList
                        [cdkDropListData]="form.socialItems()"
                        (cdkDropListDropped)="dropElementItem($event)"
                    >
                        @for (social of form.socialItems(); track $index; let i = $index) {
                            <div cdkDrag cdkDropListGroup [cdkDragData]="social">
                                <sp-control-handle
                                    [controlHandleBtn]="form.socialItems().length !== 1"
                                    [controlHandleDisableDelete]="form.socialItems().length === 1"
                                    [controlHandleIcon]="getSocialIconSrcBySocial(social)"
                                    [controlHandleMainText]="social.name"
                                    [controlHandleSubText]="getSocialSubText(social)"
                                    [controlHandleSubTextWarning]="!social.link.length"
                                    (editActionEvent)="editSocial(i)"
                                    (removeActionEvent)="removeSocial(i)"
                                />
                            </div>
                        }
                        <a class="dotted" (click)="addSocial()">{{ "add" | translate }}</a>
                    </div>
                </div>
                <div class="form-group mb-10">
                    <label class="col-xs-12">
                        {{ "control_appearance" | translate }}
                    </label>
                    <div class="col-xs-12">
                        <div class="btn-group d-flex">
                            <div
                                class="btn btn-grey w-100"
                                [class.active]="form.appearanceType().value() === EButtonType.icon"
                                (click)="onSwitchButtonType(EButtonType.icon)"
                            >
                                {{ "control_appearance_icon" | translate }}
                            </div>
                            <div
                                class="btn btn-grey w-100"
                                [class.active]="form.appearanceType().value() === EButtonType.button"
                                (click)="onSwitchButtonType(EButtonType.button)"
                            >
                                {{ "control_appearance_button" | translate }}
                            </div>
                        </div>
                    </div>
                </div>
                <!--показываем если выбран внешний вид "Кнопка"-->
                @if (!isIcon) {
                    <div class="form-group mb-20">
                        <label class="col-xs-12">
                            {{ "control_button_style" | translate }}
                        </label>
                        <div class="col-xs-6">
                            <select class="form-control" (change)="setStyleType($event)">
                                <option
                                    [value]="EButtonStyleType.primary"
                                    [selected]="form.styleType().value() === EButtonStyleType.primary"
                                >
                                    {{ "control_appearance_primary" | translate }}
                                </option>
                                <option
                                    [value]="EButtonStyleType.secondary"
                                    [selected]="form.styleType().value() === EButtonStyleType.secondary"
                                >
                                    {{ "control_appearance_secondary" | translate }}
                                </option>
                                <option
                                    [value]="EButtonStyleType.custom"
                                    [selected]="form.styleType().value() === EButtonStyleType.custom"
                                >
                                    {{ "control_appearance_custom" | translate }}
                                </option>
                            </select>
                        </div>
                        <div class="col-xs-6">
                            <sp-radio-group
                                [selected]="form.buttonSize()?.value()"
                                [type]="ERadioGroupType.size"
                                (changeSelectedEvent)="setButtonSize($event)"
                            />
                        </div>
                    </div>
                }
                @if (form.styleType().value() === EButtonStyleType.custom && !isIcon) {
                    <div class="mb-20">
                        <web-custom-button
                            [parentBase]="$any(form.buttonBase().value())"
                            [parentHover]="$any(form.buttonHover()?.value())"
                            [isIndependentCorners]="!!form.isIndependentCorners()?.value()"
                            [radiusSettings]="$any(form.advancedRadius()?.value())"
                            [advancedBorderSettings]="$any(form.advancedBorderSettings()?.value())"
                            [isAdvancedRadius]="true"
                            (valueChangeEvent)="customButtonChangeHandler($event)"
                        />
                    </div>
                }
                @if (!isIcon) {
                    <div
                        class="form-group"
                        [class.mb-20]="!form.isShadow()?.value()"
                        [class.mb-10]="form.isShadow()?.value()"
                    >
                        <label class="col-xs-9 control-label">
                            {{ "control_shadow" | translate }}
                        </label>
                        <div class="col-xs-3 text-right">
                            <sp-switch [active]="!!form.isShadow()?.value()" (toggleActiveEvent)="setShadow($event)" />
                        </div>
                    </div>
                    @if (form.isShadow()?.value()) {
                        <sp-shadow-settings-signal-legacy
                            [shadowSettings]="$any(form.shadowSettings()?.value())"
                            (valueChangeEvent)="setShadowSettings($event)"
                        />
                    }
                }
                <!--показываем якщо обрано зовнішній вигляд "Іконка"-->
                @if (isIcon) {
                    <div class="form-group mb-10">
                        <div class="col-xs-12">
                            <web-social-networks
                                [iconType]="$any(form.iconType().value())"
                                [iconNames]="ICON_NAMES"
                                [iconTypes]="ICON_TYPES"
                                (iconTypeChangeEvent)="setIconType($event)"
                            />
                        </div>
                    </div>
                }
                <!--показываем если выбран внешний вид "Иконка"-->
                @if (isIcon) {
                    <div class="form-group mb-20">
                        <label class="col-xs-7 control-label">
                            {{ "control_size" | translate }}
                        </label>
                        <div class="col-xs-5">
                            <sp-input-num
                                suffixText="px"
                                [max]="ICON_SIZE_MAX"
                                [value]="form.height().value()"
                                (valueChange)="setHeight($event)"
                            />
                        </div>
                    </div>
                }
                @if (!isSpecific()) {
                    <div class="form-group mb-10">
                        <div class="col-xs-12 device-toggle-wrapper">
                            <web-device-toggle />
                            @if (!isZero) {
                                <web-synchronize-style-toggle
                                    [active]="form.isSynchronized()"
                                    (click)="setSynchronizeStyle()"
                                />
                            }
                        </div>
                    </div>
                    @if (isDeviceDesktopSig()) {
                        <div class="form-group mb-0">
                            <p class="col-xs-12 help-block text-muted small">
                                {{ "desktop_device_hint" | translate }}
                            </p>
                        </div>
                        <ng-container *ngTemplateOutlet="desktopSettings"> </ng-container>
                    }
                    @if (isDeviceTabletSig()) {
                        <div class="form-group mb-0">
                            <p class="col-xs-12 help-block text-muted small">
                                {{ "tablet_device_hint" | translate }}
                            </p>
                        </div>
                    }
                    @if (isDeviceMobileSig()) {
                        <div class="form-group mb-0">
                            @if (isZero) {
                                <p class="col-xs-12 help-block text-muted small">
                                    {{ "mobile_zero_device_hint" | translate }}
                                </p>
                            }
                            @if (!isZero) {
                                <p class="col-xs-12 help-block text-muted small">
                                    {{ "mobile_device_hint" | translate }}
                                </p>
                            }
                        </div>
                        @if (form.isSynchronized()) {
                            @if (!isZero) {
                                <div class="form-group mb-20">
                                    <label class="col-xs-7 control-label">
                                        {{ "control_content_alignment" | translate }}
                                    </label>
                                    <div class="col-xs-5">
                                        <sp-radio-group
                                            [selected]="form.horizontalAlign().value()"
                                            [type]="ERadioGroupType.horizontalPosition"
                                            (changeSelectedEvent)="setHorizontalAlign($event)"
                                        />
                                    </div>
                                </div>
                            }
                        } @else {
                            @if (!isZero) {
                                <div class="form-group mb-20">
                                    <label class="col-xs-7 control-label">
                                        {{ "control_content_alignment" | translate }}
                                    </label>
                                    <div class="col-xs-5">
                                        <sp-radio-group
                                            [selected]="
                                                form.mobileHorizontalAlign().value() ?? form.horizontalAlign().value()
                                            "
                                            [type]="ERadioGroupType.horizontalPosition"
                                            (changeSelectedEvent)="form.setMobileHorizontalAlign($any($event))"
                                        />
                                    </div>
                                </div>
                            }
                        }
                    }
                    <ng-template #desktopSettings>
                        @if (!isZero) {
                            <div class="form-group mb-20">
                                <label class="col-xs-7 control-label">
                                    {{ "control_content_alignment" | translate }}
                                </label>
                                <div class="col-xs-5">
                                    <sp-radio-group
                                        [selected]="form.horizontalAlign().value()"
                                        [type]="ERadioGroupType.horizontalPosition"
                                        (changeSelectedEvent)="setHorizontalAlign($event)"
                                    />
                                </div>
                            </div>
                        }
                    </ng-template>
                }
            </div>
            <div class="mt-20">
                @if (isZero) {
                    <sp-extended-position-signal-settings
                        [position]="zeroPosition()"
                        [isMobile]="isDeviceMobileSig()"
                        [isTablet]="isDeviceTabletSig()"
                        [parentId]="widget().columnId"
                        (valueChangeEvent)="zeroForm.setPosition($event)"
                    />
                } @else {
                    <web-widget-position-settings
                        [isSynchronized]="form.isSynchronized()"
                        [isTablet]="isDeviceTabletSig()"
                        [isMobile]="isDeviceMobileSig()"
                        [widgetId]="widget().id"
                        [columnId]="widget().columnId"
                        [position]="defaultPosition()"
                        (positionChange)="onDefaultPositionChange($any($event))"
                    />
                }
                <div class="form-group mb-0">
                    <div class="col-xs-12">
                        <hr class="panel-options-divider" />
                    </div>
                </div>
                @if (isZero) {
                    <web-widget-extended-hide-settings
                        [hideOnDesktop]="form.hideOnDesktop().value()"
                        [hideOnTablet]="form.hideOnTablet().value()"
                        [hideOnMobile]="form.hideOnMobile().value()"
                        (hideOnDesktopChange)="form.setHideOnDesktop($event)"
                        (hideOnTabletChange)="form.setHideOnTablet($event)"
                        (hideOnMobileChange)="form.setHideOnMobile($event)"
                    />
                } @else {
                    <web-widget-hide-settings
                        [hideOnDesktop]="form.hideOnDesktop().value()"
                        [hideOnTablet]="form.hideOnTablet().value()"
                        [hideOnMobile]="form.hideOnMobile().value()"
                        (hideOnDesktopChange)="form.setHideOnDesktop($event)"
                        (hideOnTabletChange)="form.setHideOnTablet($event)"
                        (hideOnMobileChange)="form.setHideOnMobile($event)"
                    />
                }
                <div class="form-group mb-0">
                    <div class="col-xs-12">
                        <hr class="panel-options-divider" />
                    </div>
                </div>
            </div>
            <div class="mt-20">
                <web-custom-id [displayId]="form.displayId()" (valueChangeEvent)="form.setDisplayId($event)" />
            </div>
        </div>
    </div>
} @else {
    <web-social-settings
        [form]="form"
        [index]="editableSocialIndex()"
        (saveEvent)="saveSocialSettings()"
        (cancelEvent)="cancelSocialSettings()"
    />
}
